<template>
<svg :width="size" :height="size" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2 22.5264H22.0004" :stroke="color" stroke-width="2" stroke-linecap="round" />
    <path d="M12.0002 2L2 8.31579H22.0004L12.0002 2Z" :stroke="color" stroke-width="2" stroke-linejoin="round" />
    <path d="M4 9V22" :stroke="color" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M8 9V22" :stroke="color" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M16 9V22" :stroke="color" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M20 9V22" :stroke="color" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
</svg>
</template>

<script>
export default {
     name: 'CheckingAccountIcon',
 props: {
        size: {
            type: String,
            default: '24'
        },
        color: {
            type: String,
            default: ''
        },
    }
}
</script>

<style>
</style>